module.exports = {"da-dk":"デンマーク語","de-at":"ドイツ (オーストリア)","de-ch":"ドイツ (スイス)","de-de":"ドイツ語","en-au":"英国 (オーストラリア)","en-ca":"英国 (カナダ)","en-gb":"英国 (英国)","en-ie":"英国 (アイルランド)","en-nz":"英国 (ニュージーランド)","en-us":"英国 (米国)","es-es":"スペイン語","fi-fi":"フィンランド語","fr-be":"フランス (ベルギー)","fr-fr":"フランス語","it-it":"イタリア語","ja-jp":"日本語","nb-no":"ノルウェー語","nl-be":"オランダ (ベルギー)","nl-nl":"オランダ語","pl-pl":"ポーランド語","pt-br":"ポルトガル (ブラジル)","pt-pt":"ポルトガル語","ru-ru":"ロシア語","sv-se":"スウェーデン語","zh-cn":"简体中文"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/resources/localization/ja-JP/locales.json
// module id = 1313
// module chunks = 0